module.exports = __webpack_public_path__ + "static/media/lowerRisk.dd6bff78.mp3";